import React from 'react';
import { Download, Bot, Clock, TrendingUp, Zap, MessageCircle, CheckCircle, FileText } from 'lucide-react';

export default function PDFAndWhatsAppSection() {
  const whatsappNumber = "5541996131762"; // Seu WhatsApp
  const whatsappMessage = "Olá! Quero saber mais sobre o DentalBot AI.";
  const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;


 
const handleDownloadPDF = () => {
  window.open('/dentalbot-ai.pdf', '_blank');
}

return (
  <div className="w-full">
    {/* Seção PDF Premium */}
    <section className="py-20 bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50">
      <div className="max-w-7xl mx-auto px-4">

        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-2 bg-purple-100 text-purple-600 rounded-full text-sm font-semibold mb-4">
            📚 Material Gratuito
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Baixe o Guia Premium do DentalBot AI
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Entenda como clínicas odontológicas estão automatizando atendimentos, agendando mais e reduzindo o trabalho manual.
          </p>
        </div>

        {/* 3 Colunas */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">

          {/* Coluna 1 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center mb-6">
              <FileText className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">📘 O que você vai ver no PDF</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">Agenda Inteligente</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">Atendimento automático</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">IA para clínicas</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">Conversas organizadas</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">Fluxos de atendimento</span>
              </li>
            </ul>
          </div>

          {/* Coluna 2 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-500 rounded-xl flex items-center justify-center mb-6">
              <Bot className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">🤖 Por quê usar automação?</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">Menos erros</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">Mais produtividade</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">Mais agendamentos</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">Pacientes respondidos mais rápido</span>
              </li>
            </ul>
          </div>

          {/* Coluna 3 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center mb-6">
              <Zap className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">📩 Entrega instantânea</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              Você recebe o PDF na hora, sem cadastro complicado.
            </p>
            <div className="bg-gradient-to-r from-purple-100 to-pink-100 rounded-xl p-4">
              <p className="text-sm text-purple-800 font-semibold">
                ⚡ Download imediato após clicar no botão abaixo!
              </p>
            </div>
          </div>
        </div>

        {/* CTA Botão Grande PDF */}
        <div className="text-center">
          <button
            onClick={handleDownloadPDF}
            className="inline-flex items-center gap-3 px-12 py-5 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-xl font-bold rounded-full hover:from-purple-700 hover:to-pink-700 transition-all shadow-2xl hover:shadow-3xl transform hover:scale-105"
          >
            <Download className="w-7 h-7" />
            BAIXAR PDF PREMIUM (GRÁTIS)
          </button>
          <p className="text-sm text-gray-500 mt-4">
            🔒 Sem spam. Sem cadastro complicado. Download direto.
          </p>
        </div>
      </div>
    </section>

    {/* CTA WhatsApp */}
    <section className="py-16 bg-gradient-to-r from-green-500 to-emerald-500">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <div className="inline-block px-6 py-3 bg-white/20 backdrop-blur-sm rounded-full text-white font-semibold mb-6">
          💬 Atendimento Personalizado
        </div>

        <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Quer entender como a automação pode funcionar na sua clínica?
        </h3>

        <p className="text-xl text-green-50 mb-8 max-w-2xl mx-auto">
          Converse com um especialista e tire todas as suas dúvidas sobre o DentalBot AI!
        </p>

        <a
          href={whatsappURL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 px-10 py-5 bg-white text-green-600 text-xl font-bold rounded-full hover:bg-green-50 transition-all shadow-2xl hover:shadow-3xl transform hover:scale-105"
        >
          <MessageCircle className="w-7 h-7" />
          👉 Falar com um especialista
        </a>

        <div className="mt-6 flex items-center justify-center gap-6 text-green-50 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
            <span>Online agora</span>
          </div>
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4" />
            <span>Resposta em minutos</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4" />
            <span>Sem compromisso</span>
          </div>
        </div>
      </div>
    </section>
  </div>
);
}